import * as React from "react";
import Starter from "./starter";
import SlideShow from "./slideshow";
import slideshowItems from "./slideshow_items";

export default class App extends React.Component {
  render() {
    return (
      <div>
        <Starter />
        <SlideShow items={slideshowItems} />
      </div>
    )
  }
}
